/***********************************
 * NOTE: This script uses an outdated setup for actions/reducers.
 * We are now using @reduxjs/toolkit to simplify this. This script will eventually be migrated.
 * If you are setting up a new Redux view model, follow the example of the WorksheetEditor scripts instead.
 ***********************************/

import { addErrorNotice, callApi, catchWithAuthErrors } from 'Data/Helpers/rxjsHelpers';
import webApi from 'Lib/WebApi';
import { Epic, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import { actions as authActions } from '../Authentication';
import { actions as noticeActions } from '../Notices';
import { actions } from './slice';

export const get: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.getUser.toString()),
    filter(() => state$.value.authentication.isAuthenticated),
    mergeMap(() =>
      callApi(webApi.user.get({ includeExtendedClaims: true })).pipe(
        map(({ Body: data, Success: success }) => actions.getUserResolve({ data, success })),
        catchError((err) => of(actions.getUserReject({}), addErrorNotice('Failed to retrieve user details.', err)))
      )
    )
  );

export const putPassword: Epic = (action$) =>
  action$.pipe(
    ofType(actions.putUserPassword.toString()),
    mergeMap(
      ({
        payload: {
          loginName = null,
          currentPassword = null,
          newPassword = null,
          confirmPassword = null,
          onSuccess = null,
        } = {},
      }: any) =>
        callApi(
          webApi.auth.password.put({
            Body: {
              LoginName: loginName,
              OldPassword: currentPassword,
              NewPassword: newPassword,
              NewPasswordConfirm: confirmPassword,
            },
          })
        ).pipe(
          mergeMap(({ Body: { Feedback: message } }) => {
            const epicActionsOut: any[] = [];
            if (onSuccess) {
              //Will redirect if onSuccess is set to true
              epicActionsOut.push(actions.putUserPasswordRedirect({}));
            }
            epicActionsOut.push(actions.putUserPasswordResolve(message));
            epicActionsOut.push(authActions.postLogin({ username: loginName, password: newPassword }));
            epicActionsOut.push(
              noticeActions.addNotice({ message: `Password changed successfully.\r\n${message}`, severity: 'success' })
            );
            return of(...epicActionsOut);
          }),
          catchWithAuthErrors((err: any) => {
            return of(
              actions.putUserPasswordReject(err.error.message),
              addErrorNotice('Failed to update user password.', err)
            );
          })
        )
    )
  );

export const getUserFormSettings: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.getUserForm.toString()),
    filter(() => state$.value.authentication.isAuthenticated),
    mergeMap(({ payload: { userId = null } = {} }: any) =>
      callApi(webApi.user.form.settings.get({ userId })).pipe(
        map(({ Body: data, Success: success }) => actions.getUserFormResolve({ data, success })),
        catchError((err) =>
          of(actions.getUserFormReject({}), addErrorNotice('Failed to retrieve user form settings.', err))
        )
      )
    )
  );
